/* --------------------------------------------------------------------------
	Thermometer
-------------------------------------------------------------------------- */
"use strict";
var $ = jQuery;

function initThermometer() {
        var animateElements = $('.animate');
    
        function checkIfInView() {
            // console.log("Working");
            var windowHeight = $(window).height();
            var windowTop = $(window).scrollTop();
            var windowBottom = windowTop + windowHeight;
    
            animateElements.each(function() {
                var element = $(this);
                var elementHeight = element.outerHeight();
                var elementTop = element.offset().top;
                var elementBottom = elementTop + elementHeight;
    
                if (elementBottom >= windowTop && elementTop <= windowBottom && !element.data('animated')) { //Trigger animation only on first scroll
                // if (elementBottom >= windowTop && elementTop <= windowBottom) { //Trigger animation everytime the user scrolls
                    element.addClass('in-view');
                    element.data('animated', true);
                } 
                // else { //Trigger animation everytime the user scrolls
                //     element.removeClass('in-view');
                // }
            });
        }
    
        // Check on scroll
        $(window).on('scroll', checkIfInView);
    
        // Check initially in case elements are already in view
        checkIfInView();

}


    
$(initThermometer);